module.exports = __webpack_public_path__ + "static/media/3.53cbf24d.svg";